import { useTranslation } from "react-i18next";
import { Route, Routes, useNavigate, useParams } from "react-router";
import { Link } from "react-router-dom";
import { ArrowsPointingOutIcon, BanknotesIcon, HomeIcon, ShoppingBagIcon, SwatchIcon, UserCircleIcon } from "@heroicons/react/24/solid";
import { CarouselIco, shirt } from "../../../assets/images/icons";
import ProductsList from "./ProductsList";
import CategoriesList from "./CategoriesList";
import SizesList from "./SizesList";
import { blackTextLogo } from "../../../assets/images/logos";
import axios from "axios";
import useConfirmation from "../../../utils/useConfirmation";
import { AdjustmentsHorizontalIcon, ArrowLeftStartOnRectangleIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import Notify from "../../../utils/useNotify";
import { Menu, Transition } from "@headlessui/react";
import Dashboard from "./Dashboard";
import CarouselsList from "../carousels/CarouselsList";
import CreateCarousel from "../carousels/CreateCarousel";
import UpdateCarousel from "../carousels/UpdateCarousel";
import ColorsList from "./ColorsList";
import OrdersList from "./OrdersList";
import TransactionsList from "./TransactionsList";
import LanguageSelector from "../../../utils/LanguageSelector";
import OrderDetails from "../../manage-orders/OrderDetails";
import CreateProd from "./productCompos/CreateProd";
import UpdateCard from "./productCompos/UpdateProd";
import SidebarDrawer from "./SidebarDrawer";
import StockManage from "./productCompos/StockManage";

export default function Layout() {
  const { t } = useTranslation();
  const { '*': section } = useParams();
  const navigate = useNavigate();
  const localhost = process.env.REACT_APP_LOCALHOST;
  const token = localStorage.getItem('token');
  const { open, ConfirmComponent } = useConfirmation();

  const dashSections = [
    {
      icon: <HomeIcon className="shrink-0 w-[18px] h-[18px]" />,
      title: "dashboard",
      active: "",
    },
    {
      icon: <img loading="lazy" src={shirt} alt="shirt" className="shrink-0 w-[18px] h-[18px]" />,
      title: "products",
      active: "products",
    },
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" className="icon icon-tabler icons-tabler-filled icon-tabler-category"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M10 3h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1z" /><path d="M20 3h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1z" /><path d="M10 13h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1z" /><path d="M17 13a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z" /></svg>,
      title: "categories",
      active: "categories",
    },
    {
      icon: <SwatchIcon className="shrink-0 w-[18px] h-[18px]" />,
      title: "colors",
      active: "colors",
    },
    {
      icon: <ArrowsPointingOutIcon className="shrink-0 w-[18px] h-[18px]" />,
      title: "sizes",
      active: "sizes",
    },
    {
      icon: <img loading="lazy" src={CarouselIco} alt="carousel" className="shrink-0 w-[18px] h-[18px]" />,
      title: "slides",
      active: "slides",
    },
    {
      icon: <ShoppingBagIcon className="shrink-0 w-[18px] h-[18px]" />,
      title: "orders",
      active: "orders",
    },
    {
      icon: <BanknotesIcon className="shrink-0 w-[18px] h-[18px]" />,
      title: "Transactions",
      active: "transactions",
    },
  ];

  const menuItems = [
    { label: 'dashboard', icon: AdjustmentsHorizontalIcon, href: '/admin' },
    { label: 'account', icon: UserCircleIcon, href: '/admin/settings' },
    // { label: 'settings', icon: Cog8ToothIcon, href: '/account/dashboard' },
  ];

  const handleLogout = async () => {
    try {
      await axios.post(localhost + 'logout', null, { headers: { 'Authorization': `Bearer ${token}` } });
      Notify("success", t("logout-msg"));
      setTimeout(() => {
        navigate("/signin");
        localStorage.removeItem("token");
        localStorage.removeItem("username");
      }, 500);
    } catch (err) {
      Notify("success", t("logout-msg"));
      setTimeout(() => {
        navigate("/signin");
        localStorage.removeItem("token");
        localStorage.removeItem("username");
      }, 500);
    }
  };

  const handleAction = () => {
    open(
      {
        title: t("logout-confirmation-header"),
        text: t("logout-confirmation-body"),
        action: "add",
      },
      handleLogout
    );
  };

  return (
    <>
      {ConfirmComponent}
      <header className="sticky top-0 inset-x-0 flex flex-wrap md:justify-start md:flex-nowrap w-full bg-white border-b text-sm py-0.5 lg:ps-[260px] z-[5]">
        <nav className="px-4 sm:px-6 flex basis-full items-center w-full mx-auto">
          <div className="me-5 lg:me-0 lg:hidden">
            <SidebarDrawer menuList={dashSections} />
          </div>

          <div className="w-full flex items-center justify-end ms-auto gap-x-1">
            <div className="flex flex-row items-center justify-end gap-1">
              <LanguageSelector screen="dashboard-desktop" />
              <div className="h-9 border-l border-black/50 ml-2"></div>
              <Menu as="div" className="relative z-30">
                <Menu.Button className="capitalize flex items-center gap-2 max-md:gap-0 py-2 text-sm font-medium text-black hover:text-black/80">
                  <UserCircleIcon className="size-10" />
                  <div className="flex-col text-start max-md:hidden">
                    <h1 className="text-sm leading mb-0.5 font-semibold">Admin smith</h1>
                    <p className="text-xs leading-none">Admin</p>
                  </div>
                  <div className="border border-black/50 rounded-full ml-2 p-0.5">
                    <ChevronDownIcon className="h-4 w-4" />
                  </div>
                </Menu.Button>
                <Transition
                  enter="transition duration-100 ease-out"
                  enterFrom="transform scale-95 opacity-0"
                  enterTo="transform scale-100 opacity-100"
                  leave="transition duration-75 ease-out"
                  leaveFrom="transform scale-100 opacity-100"
                  leaveTo="transform scale-95 opacity-0"
                >
                  <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5">

                    {menuItems.map((item) => (
                      <Menu.Item key={item.label} as="div">
                        {({ active }) => (
                          <a href={item.href} className={`flex items-center px-4 py-2 text-sm ${active ? 'bg-gray-100' : ''}`} >
                            <item.icon className="mr-3 h-5 w-5 text-black" />
                            {t(item.label)}
                          </a>
                        )}
                      </Menu.Item>
                    ))}

                    <Menu.Item as="div">
                      {({ active }) => (
                        <button onClick={handleAction} className={`flex items-center w-full px-4 py-2 text-sm ${active ? 'bg-gray-100' : ''}`} >
                          <ArrowLeftStartOnRectangleIcon className="mr-3 h-5 w-5" />
                          {t("logout")}
                        </button>
                      )}
                    </Menu.Item>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          </div>
        </nav>
      </header>

      {/* <!--Sidebar --> */}
      <div className="hs-overlay  hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform w-[260px] h-full hidden fixed inset-y-0 start-0 bg-white border-e border-gray-200 lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 z-10">
        <div className="relative flex flex-col h-full max-h-full">
          <a href="/" className="flex justify-center w-full px-5 pt-5">
            <img loading="lazy" src={blackTextLogo} className="h-8 w-auto" alt="logo" />
          </a>
          <div className="mt-4 h-full overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300">
            <nav className="hs-accordion-group p-3 w-full flex flex-col flex-wrap">
              <ul className="flex flex-col space-y-2">
                {dashSections.map((item, index) => (
                  <li key={index}>
                    <Link to={"/admin/" + item.active} className={`${section === item.active ? "bg-gray-200" : "bg-white"} flex items-center leading-none gap-x-3.5 py-2 px-2.5 text-sm text-gray-800 rounded-lg hover:bg-gray-100 focus:outline-none focus:bg-gray-100 capitalize`}>
                      {item.icon} {t(item.title)}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </div>

      <div className="w-full lg:ps-64">
        <div className="p-4 sm:p-6 space-y-4 sm:space-y-6 min-h-[95vh] bg-gray-100">
          <Routes>
            <Route path="" element={<Dashboard />} />
            <Route path="products" element={<ProductsList />} />
            <Route path="create-product" element={<CreateProd />} />
            <Route path="update-product/:slug" element={<UpdateCard />} />
            <Route path="stock-management/:slug" element={<StockManage />} />
            <Route path="categories" element={<CategoriesList />} />
            <Route path="colors" element={<ColorsList />} />
            <Route path="sizes" element={<SizesList />} />
            <Route path="slides" element={<CarouselsList />} />
            <Route path="create-slide" element={<CreateCarousel />} />
            <Route path="update-slide/:id" element={<UpdateCarousel />} />
            <Route path="orders" element={<OrdersList />} />
            <Route path="orders/:reference" element={<OrderDetails />} />
            <Route path="transactions" element={<TransactionsList />} />
          </Routes>
        </div>
      </div>
    </>
  )
}
